import { City } from 'truck-lib'
import Vue from 'vue'
import { WorkOrderStatus } from '@/util/const'
import { helper } from '@meta-vue/util'
import imageUtil, { getImageUrl } from '@meta-vue/image-util'
import { CallTypeEnum, CallAnswerStatus } from '@/constant'
const DEFAULT_AVATAR = require('@/assets/images/default.png') // 默认客服头像
const DEFAULT_USER_AVATAR = require('@/assets/images/default_user.png') // 默认用户头像
const Config = process.env

/**
 * 时间格式化
 */
Vue.filter('datetime', (value, format, defaultLabel = '') => {
  return value ? new Date(value).Format(format || 'yyyy-MM-dd hh:mm') : defaultLabel
})

Vue.filter('yeardaytime', (value, format, defaultLabel = '') => {
  return value ? new Date(value).Format(format || 'yyyy-MM-dd') : defaultLabel
})

Vue.filter('timeSecond', (value, format, defaultLabel = '') => {
  return value ? new Date(value).Format(format || 'hh:mm:ss') : defaultLabel
})

/** 毫秒转分钟-秒 */
Vue.filter('minSecond', millisecond => {
  if (!millisecond) {
    return ''
  }
  const value = Math.ceil(millisecond / 1000)
  const m = (value % 3660) / 60 >= 1 ? parseInt(value / 60) : ''
  const s = parseInt(value % 60).toString()
  return `${m ? m + '分钟' : ''}${s ? s + '秒' : ''}`
})

// 精确到秒
Vue.filter('dateTimeSecond', (value, format = 'yyyy-MM-dd hh:mm:ss', empty = '-') => {
  return value ? new Date(value).Format(format) : empty
})

// 数字字符串 时间戳
Vue.filter('stringDateTimeSecond', (value, format) => {
  value = Number(value)
  return value ? new Date(value).Format(format || 'yyyy-MM-dd hh:mm:ss') : '未知'
})

// 精确到秒
Vue.filter('getDateTimeSecond', (value, format) => {
  return value ? new Date(value).Format(format || 'yyyy年MM月dd日 hh:mm:ss') : ''
})

// 金融数字单位
Vue.filter('moneyUnit', (value, unit = '元', fallback = '-') => {
  return typeof value === 'number' ? value + unit : value || fallback
})

// 审核状态过滤
Vue.filter('state', value => {
  switch (value) {
    case 1:
      return '审核中'
    case 2:
      return '审核完成'
    case 3:
      return '审核驳回'
    case 4:
      return '主管审核中'
    case 5:
      return '主管审核驳回'
    case 6:
      return '财务审核中'
    case 7:
      return '财务审核驳回'
    case 8:
      return '申请撤回'
    default:
      return ''
  }
})

Vue.filter('payStatus', value => {
  switch (parseInt(value, 10)) {
    case 0:
      return '未支付'
    case 1:
      return '已付到收款方'
    case 2:
      return '已退款'
    case 10:
      return '已付款到平台'
    case -1:
      return '交易取消'
    case 99:
      return '未退款到货主'
    case 15:
      return '支付确认中'
    case 25:
      return '退款中'
    default:
      return '未支付'
  }
})
/**
 * 充值时间格式化,value是以秒为单位
 */
Vue.filter('sdatetime', (value, format) => {
  const val = parseInt(value + '000')
  return value ? new Date(val).Format(format || 'yyyy-MM-dd hh:mm') : '未知'
})
/**
 * 时间格式化，只显示月日
 */
Vue.filter('daytime', (value, format) => {
  return new Date(value).Format(format || 'MM-dd')
})

/**
 * 金额格式化
 *  value 金额，以分为单位
 */
Vue.filter('moneyFormat', (value, num) => {
  if (typeof value === 'string' && value.includes('*')) return value
  value /= 100 // 转换为元
  num = typeof num === 'undefined' ? 2 : num
  if (parseFloat(value) > 0) {
    const str = parseFloat(value).toFixed(num)
    const strArr = str.split('.')
    return /^0+$/.test(strArr[1]) ? strArr[0] : str
  } else {
    return 0
  }
})
/**
 * 金额格式化
 *  value 金额，以分为单位 所有大于等于0的数字均保留num位小数
 */
Vue.filter('moneyFormatFixed', (value, num) => {
  if (typeof value === 'string' && value.includes('*')) return value
  value /= 100 // 转换为元
  num = typeof num === 'undefined' ? 2 : num
  if (parseFloat(value) >= 0) {
    const str = parseFloat(value).toFixed(num)
    return str
  } else {
    return 0
  }
})
/**
 * 金额格式化（保存不同位小数）
 *  value 金额，以分为单位
 */
Vue.filter('moneyDecFormat', value => {
  value = parseFloat(value)
  if (isNaN(value)) {
    return ''
  }
  value /= 100 // 转换为元
  if (value > 10) {
    value = value.toFixed(0)
    return value
  }
  if (value >= 1 && value <= 10) {
    value = value.toFixed(1)
    return value
  }
  if (value < 1) {
    value = value.toFixed(2)
    return value
  }
})

/**
 * 地点id转地点名称 过滤器
 */
Vue.filter('findCity', (value, deep) => {
  if (value) {
    return City.codeToName(value, deep)
  }
})

/**
 * 地点id转地点名称 过滤器
 */
Vue.filter('getKeyToValueMap', (value, deep) => {
  if (value) {
    return City.codeToName(value, deep)
  }
})

/**
 * 小数转百分比
 */
Vue.filter('percentage', num => {
  num = +num
  const numArr = num.toString().split('.')
  let result
  if (numArr.length === 2) {
    result = (parseInt(numArr.join('').replace(/^0+/, '')) * 100) / Math.pow(10, numArr[1].length)
  } else {
    result = num * 100
  }
  return num >= 0 ? result + '%' : ''
})

/**
 * 地理代码解析
 */
Vue.filter('geoCodeInfo', (code, deep) => {
  if (!code) code = '000000'
  deep *= 2
  const codeArr = [code.toString().slice(0, deep), code.toString().slice(deep)]
  let info
  if (/^0+$/.test(codeArr[1])) info = ''
  else info = City.codeToName(codeArr[0] + codeArr[1].replace(/\d/g, '0'))

  return info
})

/**
 * 地名修剪
 */
Vue.filter('trimDest', (dest, pattern) => {
  pattern = new RegExp(pattern || '[省市区县]', 'g')
  return dest.replace(pattern, '')
})

/**
 *  trim 0
 **/
Vue.filter('trimZero', str => {
  return str == 0 ? '' : str
})

/**
 * 图片地址转换
 */
Vue.filter('imageFormat', value => {
  return Config.VUE_APP_PICHOST + (value ? value.replace('.jxx', '.jpg') : '')
})

/**
 * 图片展示地址
 */
Vue.filter('imgFormat', imageUtil.filter)

/*
 图片显示
 */
Vue.filter('picture', value => {
  if (value) {
    if (value.indexOf('?x-oss-process=image/auto-orient') > -1) {
      value = value.replace('?x-oss-process=image/auto-orient', '')
    }

    return getImageUrl(value)
  }
})

/*
时间段显示
*/
Vue.filter('timeShow', value => {
  let h = value / 3600 >= 1 ? parseInt(value / 3600) : '00'
  let m = (value % 3660) / 60 >= 1 ? parseInt((value % 3600) / 60) : '00'
  const s = parseInt(value % 60)
    .toString()
    .padStart(2, '0')
  m = m.toString().padStart(2, '0')
  h = h.toString().padStart(2, '0')
  return `${h}:${m}:${s}`
})
// 时间戳转00:00:00
Vue.filter('duration', value => {
  if (!value) return '00:00:00'
  return helper.transformSecondsToClock(value)
})

/**
 * 字符串超长截取
 */
Vue.filter('stringOmit', (str, length) => {
  return str.length <= length ? str : str.substr(0, length - 1) + '...'
})

// 货源类型过滤
Vue.filter('CargoType', value => {
  switch (value) {
    case 0:
      return '普通、个人普货精选、企业普货精选'
    case 1:
      return '满运宝'
    case 2:
      return '企业满运宝'
    case 3:
      return '精品满运宝'
    case 4:
      return '个人精选满运宝'
    case 5:
      return '普货精选'
    case 10:
      return '满运宝、企业满运宝、企业精品满运宝、个人精选满运宝'
    default:
      return ''
  }
})

// 成交过滤
Vue.filter('BargainDeal', value => {
  switch (value) {
    case 0:
      return '普通'
    case 1:
      return '报价'
    case 10:
      return '全部'
    default:
      return ''
  }
})

// 责任认定
Vue.filter('responsibleParty', value => {
  switch (value) {
    case 1:
      return '投诉人责任'
    case 2:
      return '被投诉人责任'
    case 3:
      return '双方责任'
    case 4:
      return '责任不清'
    default:
      return ''
  }
})

Vue.filter('formatCountDown', value => {
  let t = ''
  if (value > -1) {
    const hour = Math.floor(value / 3600)
    const min = Math.floor(value / 60) % 60
    const sec = value % 60
    if (hour < 10) {
      t = '0' + hour + ':'
    } else {
      t = hour + ':'
    }
    if (min < 10) t += '0'
    t += min + ':'
    if (sec < 10) t += '0'
    t += sec
  }
  return t
})
/**
 * 钱包账户状态
 */
Vue.filter('accountInfoStatus', value => {
  switch (parseInt(value, 10)) {
    case -1:
      return '已冻结'
    case 0:
      return '未激活'
    case 1:
      return '正常'
    case 3:
      return '已销户'
  }
})

/**
 * 强制保留2位小数，不足补 0
 */
Vue.filter('moneyFormatToDecimal', value => {
  let f = parseFloat(value)
  if (isNaN(f)) {
    return ''
  }
  f = Math.round(value * 100) / 100
  let s = f.toString()
  let rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
})

/*
 * 保障理赔类型
 */
Vue.filter('platformInsuranceType', value => {
  switch (parseInt(value, 10)) {
    case 1:
      return '满运宝'
    case 2:
      return '帮运宝'
    case 3:
      return '满运宝企业版'
    case 4:
      return '帮运宝企业版'
    case 5:
      return '普通报价货源'
    case 6:
      return '企业报价货源'
    case 7:
      return '个人精选满运宝'
    case 8:
      return '普货精选'
  }
})

/*
 * 保障理赔状态
 */
Vue.filter('getPlatformInsuranceStatus', value => {
  switch (parseInt(value, 10)) {
    case 1:
      return '待认领'
    case 2:
      return '处理中'
    case 3:
      return '待主管确认'
    case 4:
      return '待财务审核'
    case 5:
      return '已赔付'
    case 6:
      return '已拒赔'
    case 7:
      return '主管驳回'
    case 8:
      return '财务驳回'
    case 9:
      return '待部门负责人审批'
    case 10:
      return '待事业部负责人审批'
  }
})

Vue.filter('tableCallTypeMap', val => {
  switch (parseInt(val, 10)) {
    case 1:
      return '呼入'
    case 2:
      return '呼出'
    case 3:
      return '手工创建'
    case 4:
      return '在线接待'
    case 5:
      return '在线主动接待'
    case 6:
      return '在线主动联系'
    case 7:
      return '任务外呼'
    case 8:
      return '电话呼入（95）'
    case 9:
      return '意见回访'
    default:
      return ''
  }
})

Vue.filter('tableStatusMap', val => {
  return WorkOrderStatus[parseInt(val, 10)]
})

Vue.filter('tablePriority', val => {
  let text = ''
  if (val <= -1) {
    text = '不重要'
  } else if (val >= 0 && val <= 999) {
    text = '普通'
  } else if (val >= 1000 && val <= 9999) {
    text = '紧急'
  } else {
    text = '十分紧急'
  }
  return text
})

Vue.filter('tableOrderStatus', val => {
  const tempMap = {
    0: '待处理',
    1: '处理中',
    2: '关闭'
  }
  return tempMap[parseInt(val, 10)]
})

Vue.filter('tableColdOrderStatus', val => {
  const tempMap = {
    0: '待分配',
    1: '待处理',
    2: '处理中',
    3: '已关闭'
  }
  return tempMap[parseInt(val, 10)]
})

// 成交过滤
Vue.filter('tableBargainDeal', value => {
  switch (parseInt(value, 10)) {
    case 0:
      return '普通'
    case 1:
      return '报价'
    case 2:
      return '一口价'
    case 3:
      return '议价'
    case 5:
      return '定价（短途）'
    case 6:
      return '定价（长途）'
    case 7:
      return '承运商定价'
    case 8:
      return '一口价（快车）'
    case 9:
      return '一口价（成交率）'
    case 10:
      return '定价（整车）'
    case 11:
      return '报价（快车）'
    case 12:
      return '委托货源'
    case 13:
      return '拼车'
    case 14:
      return '电议（整车）'
    case 15:
      return '拼货货源'
    default:
      return ''
  }
})

Vue.filter('tableOrderStatusMap', val => {
  const tempMap = {
    '-2': '超时取消',
    '-1': '交易失败',
    0: '已取消',
    1: '初始',
    5: '待成交',
    10: '已成交',
    15: '待确认',
    17: '司机待确认接单',
    20: '运输中',
    25: '已装货',
    30: '货已到达',
    60: '已收回单',
    90: '已完成',
    101: '议价中'
  }
  return tempMap[`${val}`]
})

Vue.filter('accountStatusFilter', val => {
  const customerStatusMap = {
    '-2': '注销',
    0: '未认证',
    1: '已认证'
  }
  const desc = customerStatusMap[`${val}`] ? customerStatusMap[`${val}`] : '未知'
  return `${val}` || val === 0 ? desc : '未注册'
})
Vue.filter('licenceTypeFilter', val => {
  const licenceTypeMap = {
    1: '黄牌',
    2: '蓝牌',
    3: '绿牌'
  }
  return licenceTypeMap[val]
})

Vue.filter('vanGoghInfoFilter', val => val)

// 开卡状态
Vue.filter('ETCBindStatus', val => {
  const StausMap = {
    0: '新订单',
    1: '开卡成功',
    2: '开卡失败/已销卡'
  }
  return StausMap[val]
})

// 销卡状态
Vue.filter('ETCCancelStatus', val => {
  const StausMap = {
    0: '待审核',
    1: '已支付',
    2: '已销卡',
    3: '已退款',
    4: '取消申请',
    5: '取消成功',
    6: '销卡过来的取消申请',
    7: '销卡过来的取消申请成功',
    8: '审核不通过',
    9: '已转卡(针对补换卡)',
    10: '审核通过',
    11: '提交中'
  }
  return StausMap[val]
})

// 销卡退费状态
Vue.filter('ETCRefundStatus', val => {
  const StausMap = {
    0: '默认',
    1: '未退款',
    2: '已退款',
    3: '退款失败',
    4: '已回款'
  }
  return StausMap[val]
})

// 出险类型
Vue.filter('ensureClaimType', val => {
  const map = {
    1: '货损',
    2: '延误',
    4: '加价',
    8: '放空',
    16: '保价运输服务'
  }
  let str = ''
  let arr = []
  if (val.length) {
    arr = val.split(',')
    arr.forEach((item, index) => {
      str += map[item]
      if (index != arr.length - 1) {
        str += '，'
      }
    })
  }
  return val ? str : ''
})

// 保障类型
Vue.filter('EnsureSource', val => {
  const StausMap = {
    1: '满运宝',
    2: '帮运宝',
    3: '企业满运宝',
    4: '企业帮运宝',
    5: '报价货源',
    6: '企业精选满运宝',
    7: '个人精选满运宝',
    9: '长尾货源',
    10: '专车一口价',
    11: '快车保障',
    12: '委托货源',
    13: '担保订金先行赔付'
  }
  return StausMap[val]
})

// 出险类型
Vue.filter('EnsureType', val => {
  const StausMap = {
    1: '货损',
    2: '延误',
    4: '加价',
    8: '放空',
    16: '保价运输服务',
    32: '加价（垫付）',
    64: '拉跑货物（垫付）',
    128: '放空（垫付）',
    256: '迟到（垫付）'
  }
  return StausMap[val]
})

// 手机号码变更记录查询 修改类型
Vue.filter('ChangeType', val => {
  const StausMap = {
    1: '自主修改',
    2: '审核修改'
  }
  return StausMap[val]
})

// 报案者角色
Vue.filter('UserType', val => {
  const roleDescMap = {
    1: '司机',
    2: '货主'
  }
  return roleDescMap[val] || ''
})

// 发货平台
Vue.filter('publishFlatFilter', val => {
  const StausMap = {
    1: '运满满',
    2: '货车帮',
    3: '运满满冷运货主APP',
    4: '省省'
  }
  return StausMap[val]
})

// 手机号码变更记录查询 修改状态
Vue.filter('VerifyStatus', val => {
  const StausMap = {
    1: '审核通过',
    '-1': '审核拒绝'
  }
  return StausMap[val]
})

// 保障理赔状态
Vue.filter('ClaimStatus', val => {
  const StausMap = {
    1: '待认领',
    2: '处理中',
    3: '待主管确认',
    4: '待财务审核',
    5: '已赔付',
    6: '已拒赔',
    7: '主管驳回',
    8: '财务驳回',
    9: '待部门负责人审批',
    10: '待事业部负责人审批'
  }
  return StausMap[val]
})

// 手机号码变更记录查询 身份
Vue.filter('AccountType', val => {
  const StausMap = {
    1: '个人司机',
    2: '个人货主',
    3: '企业管理员',
    4: '二手车'
  }
  return StausMap[val]
})
// hcb insurance
Vue.filter('hcbInsuranceFilter', val => val)

// 手机号码修改记录 审核状态
Vue.filter('verifyStatus', val => {
  const StausMap = {
    1: '审核通过',
    '-1': '审核拒绝'
  }
  return StausMap[val]
})

//咨询业务类型  关联类型
Vue.filter('RelationType', val => {
  const StausMap = {
    1: '关联知识',
    2: '关联链接',
    3: '关联组件'
  }
  return StausMap[val]
})

//咨询业务类型  关联组件
Vue.filter('RelationContent', val => {
  const StausMap = {
    1: '查询运单组件',
    2: '查询货源组件'
  }
  return StausMap[val]
})

//会话记录查询  服务评价
Vue.filter('EvaluateResult', val => {
  const StausMap = {
    '-1': '未评价',
    1: '满意',
    2: '一般般'
  }
  return StausMap[val]
})

/** 时间段显示 */
Vue.filter('timeShow', value => {
  let h = value / 3600 >= 1 ? parseInt(value / 3600) : '00'
  let m = (value % 3660) / 60 >= 1 ? parseInt((value % 3600) / 60) : '00'
  const s = parseInt(value % 60)
    .toString()
    .padStart(2, '0')
  m = m.toString().padStart(2, '0')
  h = h.toString().padStart(2, '0')
  return `${h}:${m}:${s}`
})

/** 时长格式化 入参单位为分钟*/
Vue.filter('formatDuration', value => {
  value = value * 60 || 0
  let h = value / 3600 >= 1 ? parseInt(value / 3600) : '00'
  let m = (value % 3660) / 60 >= 1 ? parseInt((value % 3600) / 60) : '00'
  const s = parseInt(value % 60)
    .toString()
    .padStart(2, '0')
  m = m.toString().padStart(2, '0')
  h = h.toString().padStart(2, '0')
  return `${h}:${m}`
})

/** 时长格式化 */
Vue.filter('formatTime', value => {
  if (!value) return '00:00'
  const seconds = Number(value % 60)
    .toString()
    .padStart(2, '0')
  const minute = Math.floor(value / 60)
    .toString()
    .padStart(2, '0')
  if (value > 60 * 60) {
    const hour = Math.floor(value / (60 * 60))
      .toString()
      .padStart(2, '0')
    return `${hour}:${minute}:${seconds}`
  } else {
    return `${minute}:${seconds}`
  }
})

/**
 * 获取头像过滤器
 *
 * @param {String} 用户头像地址
 * @param {String} 客服头像地址
 * @param {String} 气泡是否客服发送
 * @returns {String} 新的头像地址
 */
Vue.filter('getImMsgAvatar', (userAvatar, serviceAvatar, position) => {
  let src = ''
  let default_avatar = ''
  if (position == 'right') {
    src = serviceAvatar
    default_avatar = 'https://imagecdn.ymm56.com/ymmfile/static/resource/2d23e247-2019-42ad-a4a7-48c133dfd991.png'
  } else {
    src = userAvatar
    default_avatar = 'https://imagecdn.ymm56.com/ymmfile/static/resource/af37d46f-2268-4e85-a473-aa2b2df33af1.png'
  }
  return src ? getImageUrl(src) : default_avatar
})

/**
 * 获取头像地址 没有用默认地址
 *
 * @param {String} 头像地址
 */
Vue.filter('personPicture', val => {
  return val ? getImageUrl(val) : DEFAULT_AVATAR
})

//投诉单状态
Vue.filter('complaintStatus', val => {
  return WorkOrderStatus[val] ? WorkOrderStatus[val] : val
})

// 通话类型
Vue.filter('callTypeFilter', val => {
  return CallTypeEnum.labels[val]
})

// 呼叫状态
Vue.filter('callStatusFilter', val => {
  return CallAnswerStatus.labels[val]
})

// 权限状态全局过滤器
Vue.filter('accountFullStatusFilter', (customerDetail = {}) => {
  if (!customerDetail) return ''
  const { customerStatus, userLogoffFreezePeriodFlag } = customerDetail
  if (userLogoffFreezePeriodFlag) return '注销冻结中'
  const customerStatusMap = {
    '-2': '注销',
    0: '未认证',
    1: '已认证'
  }
  return `${customerStatus}` || customerStatus === 0
    ? customerStatusMap[`${customerStatus}`]
      ? customerStatusMap[`${customerStatus}`]
      : '未知'
    : '未注册'
})
